<template>
  <v-container fluid>
    <h1 class="mb-5">Reikalavimo teisės perleidimas</h1>

    <check-errors text-only />
    <v-card class="pa-5">
      <el-overlay-loading :loading="pageloading" />

      <v-card-text class="pt-0">
        <div class="dataContainer2">
          <h3 class="mt-5 mb-3">
            Reikalavimo teisę perleidžiantis kreditorius (-iai)
          </h3>
          <perleidimas-asmenys
            :asmuo-role="perleidziaRole"
            :asmenys="perleidziaAsmenys"
            :readonly="perleidziaReadonly"
            @savedAsmuo="savedPerleidzia"
            @deletedAsmuo="deletedPerleidzia"
          />

          <h3 class="mt-5 mb-3">
            Hipotekos, įkeitimai
          </h3>
          <perleidimas-objektai
            :readonly="objektaiReadonly"
            :perleidzia-ids="perleidziaIds"
            :objektai="objektai"
            @savedObjektas="savedObjektas"
            @deletedObjektas="deletedObjektas"
          />

          <h3 class="mt-5 mb-3">
            Kreditorius (-iai), kuriam perleidžiamos teisės
          </h3>
          <perleidimas-asmenys
            :asmuo-role="priimaRole"
            :asmenys="priimaAsmenys"
            :readonly="priimaReadonly"
            @savedAsmuo="savedPriima"
            @deletedAsmuo="deletedPriima"
          />

          <h3 class="mt-5 mb-3">
            Prisegamos rinkmenos
          </h3>
          <perleidimas-upload
            multiple
            :uploadedFiles="uploadedFiles"
            :progress="uploadProgress"
            :readonly="uploadReadonly"
            :max-dydis="6"
            @savedData="savedUpload"
          />
        </div>
        <v-footer class="form-footer">
          <el-button
            :loading="loading"
            primary
            @click.native.stop="confirmData()"
          >
            Perduoti
          </el-button>
          <el-button :loading="loading" @click.native="clearData()">
            Išvalyti
          </el-button>
        </v-footer>
      </v-card-text>
    </v-card>

    <modal-confirm
      title="Reikalavimo teisės perleidimas"
      text="Ar norite perduoti duomenis?"
      action="Perleidimas"
      v-model="showConfirm"
      @confirmPerleidimas="saveData"
    />
  </v-container>
</template>

<script>
import HipotekaMap from '../hipoteka/hipotekaMap'
import ModalConfirm from '../modals/ModalConfirm'
import userRole from '../../mixins/userRole'
import CheckErrors from '../hipoteka/CheckErrors'
import PerleidimasAsmenys from './PerleidimasAsmenys'
import PerleidimasObjektai from './PerleidimasObjektai'
import PerleidimasUpload from './PerleidimasUpload'

export default {
  name: 'HipotekaPerleidimas',
  components: {
    CheckErrors,
    ModalConfirm,
    PerleidimasAsmenys,
    PerleidimasObjektai,
    PerleidimasUpload,
  },
  mixins: [userRole],
  data() {
    return {
      pageloading: true,
      loading: true,
      perleidziaAsmenys: [],
      priimaAsmenys: [],
      objektai: [],
      uploadProgress: 0,
      uploadedFiles: [],
      showConfirm: false,
    }
  },
  computed: {
    perleidziaRole() {
      return HipotekaMap['asmenysRoles'].perleidzia
    },
    priimaRole() {
      return HipotekaMap['asmenysRoles'].priima
    },
    perleidziaReadonly() {
      return this.objektai.length > 0 || this.loading
    },
    priimaReadonly() {
      return this.loading
    },
    objektaiReadonly() {
      return this.loading
    },
    objektaiKlaida() {
      return this.objektai.filter(objektas => objektas.klaida).length > 0
    },
    uploadReadonly() {
      return this.loading
    },
    perleidziaIds() {
      return this.perleidziaAsmenys.map(asmuo => {
        return asmuo.amn_id
      })
    },
  },
  created() {
    this.pageloading = false
    this.loading = false
  },
  methods: {
    asmuoExists(asmenys, amn_id) {
      return asmenys.filter(asmuo => asmuo.amn_id === amn_id).length > 0
    },
    checkAsmuo(amn_id) {
      return (
        this.asmuoExists(this.perleidziaAsmenys, amn_id) ||
        this.asmuoExists(this.priimaAsmenys, amn_id)
      )
    },
    savedPerleidzia(asmuo) {
      if (this.checkAsmuo(asmuo.amn_id)) {
        window._VMA.$emit('DATA_ERROR', 'Toks asmuo jau pridėtas')
        return
      }
      this.perleidziaAsmenys.push(asmuo)
    },
    savedPriima(asmuo, edit) {
      if (edit) {
        const index = this.priimaAsmenys.findIndex(
          item => item.amn_id == asmuo.amn_id
        )
        if (index > -1) {
          this.priimaAsmenys.splice(index, 1, asmuo)
        }
      } else {
        if (this.checkAsmuo(asmuo.amn_id)) {
          window._VMA.$emit('DATA_ERROR', 'Toks asmuo jau pridėtas')
          return
        }
        this.priimaAsmenys.push(asmuo)
      }
    },
    savedObjektas(objektasList) {
      this.objektai = objektasList.concat(this.objektai)
    },
    savedUpload(uploadedFiles) {
      this.uploadedFiles = uploadedFiles
    },
    deletedPerleidzia(asmuo) {
      const index = this.perleidziaAsmenys.findIndex(
        item => item.amn_id === asmuo.amn_id
      )
      if (index > -1) {
        this.perleidziaAsmenys.splice(index, 1)
      }
    },
    deletedPriima(asmuo) {
      const index = this.priimaAsmenys.findIndex(
        item => item.amn_id === asmuo.amn_id
      )
      if (index > -1) {
        this.priimaAsmenys.splice(index, 1)
      }
    },
    deletedObjektas(objektas) {
      const index = this.objektai.findIndex(
        item =>
          item.obj_identifikavimo_kodas === objektas.obj_identifikavimo_kodas
      )
      if (index > -1) {
        this.objektai.splice(index, 1)
      }
    },
    clearData() {
      this.perleidziaAsmenys = []
      this.priimaAsmenys = []
      this.objektai = []
      this.uploadedFiles = []
    },
    confirmData() {
      let klaidos = []
      if (this.perleidziaAsmenys.length == 0) {
        klaidos.push({
          message:
            'Neįvestas reikalavimo teisę perleidžiantis kreditorius (-iai)',
          type: 'error',
        })
      }
      if (this.priimaAsmenys.length == 0) {
        klaidos.push({
          message: 'Neįvestas kreditorius (-iai), kuriam perleidžiamos teisės',
          type: 'error',
        })
      }
      if (this.objektaiKlaida) {
        klaidos.push({
          message: 'Pateiktos klaidingos hipotekos, įkeitimai',
          type: 'error',
        })
      }
      if (this.objektai.length == 0) {
        klaidos.push({
          message: 'Neįvestos hipotekos, įkeitimai',
          type: 'error',
        })
      }
      if (this.uploadedFiles.length == 0) {
        klaidos.push({
          message: 'Neprisegtos rinkmenos',
          type: 'error',
        })
      }

      if (klaidos.length > 0) {
        this.$store.dispatch('checkErrors', klaidos)
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
        return
      }
      this.$store.dispatch('checkErrors', null)
      this.showConfirm = true
    },
    saveData() {
      this.loading = true

      const config = {
        onUploadProgress: progressEvent => {
          this.uploadProgress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
        },
      }

      let data = new FormData()

      this.perleidziaAsmenys.forEach((asmuo, index) => {
        data.append(`perleidziantys[${index}]`, asmuo.amn_id)
      })
      this.objektai.forEach((objektas, index) => {
        data.append(`idk[${index}]`, objektas.obj_identifikavimo_kodas)
      })
      this.priimaAsmenys.forEach((asmuo, index) => {
        data.append(`priimantys[${index}][amn_id]`, asmuo.amn_id)
        data.append(`priimantys[${index}][adr_text]`, asmuo.adresas.text)
      })

      this.uploadedFiles.forEach((byla, index) => {
        data.append(`byla[${index}]`, byla)
      })

      this.$axios
        .post(`perleidimas/perduoti`, data, config)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.clearData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
</style>
